import { BarChartItem, PieSlice } from '../dashboard-operacional/dashboard-operacional.mock';

export interface PatioKpiItem {
  key: 'capacidade' | 'agendados' | 'disponiveis' | 'no-patio' | 'cancelados';
  label: string;
  value: number;
  hint?: string;
}

export interface PermanenciaBucket {
  label: string;
  value: number;
  tone: 'danger' | 'warning' | 'success' | 'success-light';
}

export interface AgendamentoDiaResumo {
  totalVagas: number;
  agendados: number;
  noPatio: number;
  cancelados: number;
  prePatio: number;
}

export interface AgendamentoDiaCardItem {
  key: 'total-vagas' | 'agendados' | 'no-patio' | 'pre-patio' | 'cancelados';
  label: string;
  value: number;
  hint?: string;
}

export interface AgendamentoDiaPainelConfig {
  titulo: string;
  subtitulo: string;
  badge: string;
  theme: 'd' | 'd1' | 'd2';
}

export type VeiculoTurnoStatus = 'em-andamento' | 'atrasado' | 'finalizado' | 'previsto' | 'vazio';

export interface TurnoVeiculo {
  placa: string;
  motorista: string;
  status: VeiculoTurnoStatus;
  pkAgnd?: number | null;
  pkGateEntr?: number | null;
  pkGateSaid?: number | null;
}

export interface TurnoInfo {
  horario: string;
  ocupados: number;
  capacidade: number;
  veiculos: TurnoVeiculo[];
}

export const PATIO_TERMINAIS = [
  { value: '1', label: 'HIDROVIAS DO BRASIL' },
  { value: '2', label: 'CARGILL' },
  { value: '3', label: 'UNITAPAJOS' },
  { value: '4', label: 'CIAMPORT' }
];

export const PATIO_PRODUTOS = [
  { value: 'MILHO', label: 'MILHO' },
  { value: 'SOJA', label: 'SOJA' },
  { value: 'FARELO', label: 'FARELO' }
];

export const PATIO_TOTAL_VEICULOS: PatioKpiItem[] = [
  { key: 'capacidade', label: 'Capacidade total', value: 3000, hint: 'Vagas do pátio' },
  { key: 'agendados', label: 'Agendados', value: 980, hint: 'Com agendamento confirmado' },
  { key: 'disponiveis', label: 'Vagas disponíveis', value: 2020, hint: 'Livres para novos agendamentos' },
  { key: 'no-patio', label: 'No pátio agora', value: 400, hint: 'Veículos no terminal' },
  { key: 'cancelados', label: 'Cancelados', value: 22, hint: 'No período selecionado' }
];

export const PATIO_AGENDADO_TERMINAIS: BarChartItem[] = [
  { label: 'HIDROVIAS', value: 980 },
  { label: 'CARGILL', value: 420 },
  { label: 'UNITAPAJOS', value: 345 },
  { label: 'CIAMPORT', value: 300 },
  { label: 'BERTUOL', value: 255 },
  { label: 'UNI-Z', value: 200 },
  { label: 'DIVERSOS', value: 0 }
];

export const PATIO_NO_PATIO_TERMINAIS: BarChartItem[] = [
  { label: 'HIDROVIAS', value: 200 },
  { label: 'CARGILL', value: 120 },
  { label: 'UNITAPAJOS', value: 40 },
  { label: 'CIAMPORT', value: 25 },
  { label: 'BERTUOL', value: 10 },
  { label: 'UNI-Z', value: 5 },
  { label: 'DIVERSOS', value: 0 }
];

export const PATIO_PERMANENCIA: PermanenciaBucket[] = [
  { label: '> 24h', value: 0, tone: 'danger' },
  { label: '19h - 24h', value: 0, tone: 'danger' },
  { label: '14h - 19h', value: 0, tone: 'danger' },
  { label: '9h - 14h', value: 50, tone: 'warning' },
  { label: '4h - 9h', value: 65, tone: 'success-light' },
  { label: '< 4h', value: 64, tone: 'success' }
];

export const PATIO_DIARIO_TOTAL: { totalKg: number; slices: PieSlice[] } = {
  totalKg: 10824500,
  slices: [
    { label: 'Finalizado', value: 0, color: '#16a34a' },
    { label: 'Em andamento', value: 8639940, color: '#7c3aed' },
    { label: 'Previsto', value: 1740370, color: '#1e3a8a' },
    { label: 'Atrasado', value: 444190, color: '#dc2626' },
    { label: 'Adiantado', value: 120000, color: '#0891b2' },
    { label: 'Pré-pátio', value: 85000, color: '#ea580c' }
  ]
};

export const PATIO_AGENDAMENTOS_D: AgendamentoDiaResumo = {
  totalVagas: 300,
  agendados: 200,
  noPatio: 100,
  cancelados: 50,
  prePatio: 20
};

export const PATIO_AGENDAMENTOS_D1: AgendamentoDiaResumo = {
  totalVagas: 300,
  agendados: 200,
  noPatio: 100,
  cancelados: 55,
  prePatio: 15
};

export const PATIO_AGENDAMENTOS_D2: AgendamentoDiaResumo = {
  totalVagas: 300,
  agendados: 180,
  noPatio: 0,
  cancelados: 12,
  prePatio: 0
};

const emptySlots = (count: number): TurnoVeiculo[] =>
  Array.from({ length: count }, () => ({
    placa: '',
    motorista: '',
    status: 'vazio' as const
  }));

export const PATIO_TURNOS: TurnoInfo[] = [
  {
    horario: '00:00 – 07:00',
    ocupados: 780,
    capacidade: 800,
    veiculos: [
      { placa: 'QDF7J89', motorista: 'José Alves da Silva', status: 'em-andamento' },
      { placa: 'MLV1t21', motorista: 'Raimundo Pereira de Aguiar', status: 'em-andamento' },
      ...emptySlots(4)
    ]
  },
  {
    horario: '07:00 – 15:00',
    ocupados: 150,
    capacidade: 800,
    veiculos: [
      { placa: 'RRA5G55', motorista: 'Ernesto de Oliveira', status: 'atrasado' },
      { placa: 'DCP2F45', motorista: 'Pedro Abreu Ferreira', status: 'finalizado' },
      ...emptySlots(4)
    ]
  },
  {
    horario: '15:00 – 23:00',
    ocupados: 20,
    capacidade: 700,
    veiculos: emptySlots(6)
  }
];
